import * as React from "react";
import { User } from "../../userTypes";

type Props = {
  user: User;
};

export default class IdentityVerification extends React.Component<Props> {
  render() {
    const { user } = this.props;

    return (
      <section className="page">
        <table
          style={{
            fontSize: "14px",
            paddingTop: "-20px",
            width: "100%",
          }}
          className="BOTable"
          cellPadding={0}
          cellSpacing={0}
        >
          <thead>
            <tr>
              <td colSpan={6}>
                <h3
                  style={{
                    borderBottom: "1px solid rgb(204, 204, 204)",
                    fontWeight: 400,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <p style={{ flex: 1 }}>iidentifii identity verifications</p>
                </h3>
              </td>
            </tr>

            {user.identity_verification != null ? (
              <tr>
                <th style={{ textAlign: "left" }}>
                  <b style={{ color: "#555" }}>Identity verification status</b>
                </th>
                <th style={{ textAlign: "left" }}>
                  <b style={{ color: "#555" }}>Error reason</b>
                </th>
                <th style={{ textAlign: "left" }}>
                  <b style={{ color: "#555" }}>Created at</b>
                </th>
                <th style={{ textAlign: "left" }}>
                  <b style={{ color: "#555" }}>Updated at</b>
                </th>
              </tr>
            ) : (
              <tr />
            )}
          </thead>
          {user.identity_verification == null ? (
            <tbody>
              <tr
                style={{
                  background: "#F9F9F9",
                }}
              >
                <td>
                  {" "}
                  There are no identity verifications records for this user.{" "}
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              {user.identity_verification_history.map(
                (identity_verification, index) => {
                  return (
                    <tr key={index}>
                      <td> {identity_verification.status} </td>
                      <td> {identity_verification.error_reason} </td>
                      <td> {identity_verification.created_at} </td>
                      <td> {identity_verification.updated_at} </td>
                    </tr>
                  );
                }
              )}
            </tbody>
          )}
        </table>
      </section>
    );
  }
}
